/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScoreConcertDto as FeatureMusicLibraryScoreConcertDto } from '../../models/feature/music-library/score-concert-dto';

export interface GetScoreConcerts$Params {
  scoreId: number;
}

export function getScoreConcerts(http: HttpClient, rootUrl: string, params: GetScoreConcerts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureMusicLibraryScoreConcertDto>>> {
  const rb = new RequestBuilder(rootUrl, getScoreConcerts.PATH, 'get');
  if (params) {
    rb.path('scoreId', params.scoreId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<Array<FeatureMusicLibraryScoreConcertDto>>;
    })
  );
}

getScoreConcerts.PATH = '/music-library/score-concerts/{scoreId}';

function reviveFeatureMusicLibraryScoreConcertDto(value: any): any {
  if (value) {
    if (value["date"] != null) {
      value["date"] = parseDateTime(value["date"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body) {
    for (let i0 = 0; i0 < body.length; i0++) {
      if (body[i0] != null) {
        body[i0] = reviveFeatureMusicLibraryScoreConcertDto(body[i0]);
      }
    }
  }
  return body;
}
